import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useBlog } from '../../context/BlogContext';
import formatDate from '../../utils/formatDate';
import client from '../../api/client';

export default function ArchiveList() {
	const [titles, setTitles] = useState([]);
	const [loading, setLoading] = useState(false);
	const fetchData = async () => {
		try {
			setLoading(true);
			const titles = await client.get('/blog/archive');
			setTitles(titles.data.titles);
			setLoading(false);
		} catch (error) {
			setLoading(false);
			return console.error(error);
		}
	};

	useEffect(() => {
		fetchData();
	}, []);
	const [visibleCount, setVisibleCount] = useState(15); // Initial number of items to show
	const [displayedTitles, setDisplayedTitles] = useState([]); // Array to hold displayed titles

	useEffect(() => {
		if (titles) {
			// Slice the original titles array to get only the titles that should be displayed
			setDisplayedTitles(titles.slice(0, visibleCount));
		}
	}, [titles, visibleCount]);

	const handleShowMore = () => {
		setVisibleCount((prevCount) => prevCount + 10); // Increase visible count by 10
	};

	return (
		<div className='mt-36rounded-md px-2 py-6'>
			<div>
				<div className='mx-auto w-full max-w-2xl border-t border-gray-900/10 pt-12 sm:pt-16 lg:mx-0 lg:max-w-none lg:border-t-0 lg:pt-0'>
					<div className='-my-12 divide-y divide-gray-900/10'>
						<Link to='/blog/archive'>
							<h2 className='hover:text-gray-600 text-4xl font-bold tracking-tight text-gray-800 sm:text-3xl mb-4'>
								Archive
							</h2>
						</Link>
						{displayedTitles &&
							displayedTitles.map((post, i) => {
								return (
									<article
										key={post?._id}
										className='py-2'
									>
										<div className='group relative max-w-xl'>
											<time
												dateTime={post?.date}
												className='block text-sm leading-6 text-gray-600'
											>
												{post?.date}
											</time>
											<h2 className='mt-2 text-sm font-semibold text-gray-900 group-hover:text-primary-600'>
												<Link to={post.href}>
													<span className='absolute inset-0' />
													{post?.name}
												</Link>
											</h2>
										</div>
										{/* <div className='mt-4 flex'>
											<Link
												to={`/blog/${post.href}`}
												className='relative flex gap-x-2.5 text-sm font-semibold
												leading-6 text-gray-900'
											>
												<img
													src={post?.img}
													alt=''
													className='h-6 w-6 flex-none rounded-full bg-gray-50'
												/>
												{post?.title}
											</Link>
										</div> */}
									</article>
								);
							})}
					</div>
				</div>
			</div>
			<div className='mt-4'>
				{visibleCount < titles.length && ( // Only show "Show More" button if there are more items to display
					<button
						onClick={handleShowMore}
						className='mt-14 rounded hover:bg-primary-400 bg-primary-600 px-2.5 py-1.5 text-sm font-semibold text-black shadow-sm'
					>
						Show More
					</button>
				)}
			</div>
		</div>
	);
}
